import Seo, { organizationSchema } from "@/lib/seo";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/motion/Marquee";
import Intro from "@/components/sections/Intro";
import CoreAreas from "@/components/sections/CoreAreas";
import ServicesGrid from "@/components/sections/ServicesGrid";
import Approach from "@/components/sections/Approach";
import WhyChoose from "@/components/sections/WhyChoose";
import Industries from "@/components/sections/Industries";
import FeaturedProgrammes from "@/components/sections/FeaturedProgrammes";
import FireFeature from "@/components/sections/FireFeature";
import TestimonialsSection from "@/components/sections/TestimonialsSection";
import CTASection from "@/components/CTASection";
import { useSite } from "@/hooks/content";

export default function Home() {
  const { site } = useSite();

  return (
    <>
      <Seo
        title="Workplace Safety & Fire Safety Consultancy & Training"
        description="SKY Training & Consultancy is a Singapore-based Workplace Safety & Health and Fire Safety consultancy and training company helping organisations build safer, compliant, better-prepared workplaces."
        path="/"
        schema={organizationSchema(site)}
      />
      <Hero />
      <Marquee />
      <Intro />
      <CoreAreas />
      <ServicesGrid />
      <Approach />
      <WhyChoose />
      <Industries />
      <FeaturedProgrammes />
      <FireFeature />
      <TestimonialsSection />
      <CTASection />
    </>
  );
}
